import { Modal } from "antd";
import React from "react";
import Icon from "../../../assets/icons";

// Define a type for allowed action types
type ModalActionType = "approved" | "delete" | "rejected";

interface ActionModalProps {
  visible: boolean;
  onCancel: () => void;
  onConfirm: () => void;
  title: string;
  content: string;
  confirmText?: string;
  cancelText?: string;
  actionType: ModalActionType; 
}

const ActionModal: React.FC<ActionModalProps> = ({
  visible,
  onCancel,
  onConfirm,
  title,
  content,
  confirmText,
  cancelText = "No, Go back",
  actionType,
}) => {
  const confirmButtonClass = actionType === "approved" 
    ? "bg-[#D97706] hover:bg-[#D97702]" 
    : actionType === "rejected"
    ? "bg-[#9E3D3D] hover:bg-[#B94C4C]"
    : "bg-[#D97706] hover:bg-[#D97702]";

  return (
    <Modal
      visible={visible}
      onCancel={onCancel}
      footer={null}
      closable={true}
      width={567}
      style={{
        position: 'absolute',
        top: '10px',      
        right: '20px', 
        margin: 0,  
        paddingBottom: 0, 
      }}
    >
      <div className="text-left">
        <h3 className="text-lg font-semibold flex gap-4">
          <Icon name="warningIcon" /> 
          {title}
        </h3>
        <p className="mb-6 ml-12 text-gray-600">{content}</p>

        <div className="flex ml-12 gap-4">
          <button
            onClick={onConfirm}
            className={`p-2 ${confirmButtonClass} hover:opacity-80 rounded-full text-white border-none`}
          >
            {confirmText || 
              (actionType === "approved" ? "Yes, Approve" : 
              actionType === "delete" ? "Yes, Delete" : 
              "Yes, Decline")}
          </button>
          <button
            onClick={onCancel}
            className="p-2 bg-transparent border rounded-full border-[#9D9898] text-[#4E4E4E]"
          >
            {cancelText}
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default ActionModal;
